export const WHITE_SPACE = " ";
